// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q9-9";
export var arrowButtonContainer = "_q9-5";
export var arrowButtonIcon = "_q9-6";
export var carouselArrowButton = "_q9-2";
export var carouselElementContainer = "_q9-1";
export var currentSlide = "_q9-8";
export var left = "_q9-3";
export var otherSlide = "_q9-a";
export var productCarouselContainer = "_q9-0";
export var right = "_q9-4";
export var sliderOverflow = "_q9-7";